module.exports = __webpack_public_path__ + "23fa8559f2151634fbc7834df95b8179.png";